import { createContext, useContext } from 'react';

/** Aviso breve (0.3): «Cambios guardados.» en negro o un error en rojo con «Reintentar». Dura 3,2 s. */
export interface AvisoBreve {
    tipo: 'ok' | 'error';
    texto: string;
    reintentar?: () => void;
}

export type MostrarAviso = (aviso: AvisoBreve) => void;

export const ContextoAvisoBreve = createContext<MostrarAviso>(() => undefined);

export function useAvisoBreve(): MostrarAviso {
    return useContext(ContextoAvisoBreve);
}

export const DURACION_AVISO_MS = 3200;
